// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import appConfig from './config/base.js'
import Http from './common/request'
import { digitalFlop,scrollBoard,waterLevelPond,loading } from '@jiaminghi/data-view'
import { Loading,Popup ,NoticeBar ,Switch,Notify,Dialog,Pagination    } from 'vant';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// import {Push} from '@/utils/push'
// var connection = new Push({
//   // url: 'wss://v.pole.anhuixindun.com/ws', // websocket地址正式(一期)
//   // app_key: '4dd36dcd4be929378cdb5212126cfdfc',//一期
//   url: 'wss://v2.pole.anhuixindun.com/ws', // websocket地址正式(二期)
//   app_key: 'ebf4f80c3a4de85f2cb1c23a3fd7bf1b',//二期
//   auth: '/plugin/webman/push/auth' // 订阅鉴权(仅限于私有频道)一期/二期



//   // url: 'wss://gt2.testx.dev.ahtianqiao.com/ws', // websocket地址测试(二期)
//   // url: 'wss://v.pole.anhuixindunzhecom/ws_test', // websocket地址正式(二期)
//   // app_key: 'ebf4f80c3a4de85f2cb1c23a3fd7bf1b',//二期  
//   // auth: '/plugin/webman/push/auth' // 订阅鉴权(仅限于私有频道)二期未改动
// });
// Vue.prototype.$eventBus = new Vue();
// // Vue.prototype.$connection =connection;
// var user_channel =connection.subscribe('pole_notice');
// console.log('---->',connection)
// Vue.prototype.$user_channel =user_channel;

Vue.use(Viewer)
Vue.use(digitalFlop)
Vue.use(scrollBoard)
Vue.use(waterLevelPond)
Vue.use(Pagination)
Vue.use(loading)
Vue.use(Loading);
window.$http = Http;
Vue.prototype.appConfig = appConfig;

Vue.config.productionTip = false;

// router.beforeEach((to, from, next) => {
//   if (to.path === '/login') {
//     next();
//   } else {
//     let token = localStorage.getItem('token');
//     if (token === null || token === '') {
//       next('/login');
//     } else {
//       next();
//     }
//   }
// });
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js